import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validator} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';

@Directive({
  selector: '[validatePassword]',
  providers: [{provide: NG_VALIDATORS, useExisting: ValidatePasswordDirective, multi: true}]
})
export class ValidatePasswordDirective implements Validator {

  @Input() minLen = 0 ;
  @Input() minUpper = 1;
  @Input() minLower = 1;
  @Input() minSpecialChar = 1;
  @Input() minNumberDigit = 1;

  constructor (private translate: TranslateService) {}

  validate(control: AbstractControl): {[key: string]: any} {
    const value = control.value;
    return this.validateString(value);
  }

  validateString( pwd: string): {[key: string]: any} {
    if (this.minLen<=0){
      return null;
    }

    if (!pwd) {
      let msg = 'PasswordValidationNoPassword';
      if (this.translate) {
        msg = this.translate.instant(msg);
      }
      return {['validatePassword']: msg };
    }
    if (pwd.length<this.minLen){
      let msg = 'PasswordValidationMinLen';
      if (this.translate) {
        msg = this.translate.instant(msg,{minLen: this.minLen});
      }
      return {['validatePassword']: msg };
    }else{
      let nbUpper = 0;
      let nbLower = 0;
      let nbDigit = 0;
      let special = 0;

      for (let idx = 0; idx< pwd.length;idx++){
        if(/[A-Z]/.test(pwd.charAt(idx))){
          nbUpper++;
        }else if(/[a-z]/.test(pwd.charAt(idx))){
          nbLower++;
        } else if(/[0-9]/.test(pwd.charAt(idx))){
          nbDigit++;
        }else{
          special++;
        }
      }
      let msg = null;
      if (nbUpper<this.minUpper){
        msg = 'PasswordValidationMinUpper';
        if (this.translate) {
          msg = this.translate.instant(msg,{minUpper:this.minUpper, need:(this.minUpper-nbUpper)});
        }
      }
      if (nbLower<this.minLower){
        if (msg && msg.length>0){
          msg += ' ';
        }
        if (!msg){
          msg='';
        }
        const translateCode = 'PasswordValidationMinLower';
        if (this.translate) {
          msg += this.translate.instant(translateCode,{minLower:this.minLower, need:(this.minLower-nbLower)});
        }else{
          msg += translateCode;
        }
      }
      if (nbDigit<this.minNumberDigit){
        if (msg && msg.length>0){
          msg += ' ';
        }
        if (!msg){
          msg='';
        }
        const translateCode = 'PasswordValidationMinNumberDigit';
        if (this.translate) {
          msg += this.translate.instant(translateCode,{minNumberDigit:this.minNumberDigit, need:(this.minNumberDigit-nbDigit)});
        }else{
          msg += translateCode;
        }
      }
      if (special<this.minSpecialChar){
        if (msg && msg.length>0){
          msg += ' ';
        }
        if (!msg){
          msg='';
        }
        const translateCode = 'PasswordValidationMinSpecialChar';
        if (this.translate) {
          msg += this.translate.instant(translateCode,{minSpecialChar:this.minSpecialChar, need:(this.minSpecialChar-special)});
        }else{
          msg += translateCode;
        }
      }
      if (msg){
        return {['validatePassword']: msg };
      }
      return null;


    }

  }
  /*

  isValid(pwd: string, minLen: number, minUpper: number, minLower: number, minSpecialChar: number, minNumberDigit: number, translate: TranslateService ):ValidationResult{
    const res = new ValidationResult();
    if (pwd){


    }else{
      res.error = true;
      res.messages.push(translate.instant('PasswordValidation.NoPassword'));
    }
    return res;
  }
   */



}
